<semeris-hint-overlay
  [contentContainerClass]="['semeris-overlay-container', 'manager-approval-overlay', 'mat-elevation-z4']"
  [overlayPanelClass]="['semeris-overlay']"
  (open)="onOpen()">
  >
  <ng-template #hintText>
    <button
      *permissions="[Permissions.READ_MEMO]"
      semerisButton
      variant="text"
      class="catalog-tools"
      disableRipple="true">
      <span class="display-large">Manager Approval</span>
      <mat-icon aria-hidden="false">expand_more</mat-icon>
    </button>
  </ng-template>
  <ng-template #hintContent>
    @let memo = memo$ | async;
    @let submitInProgress = submitInProgress$ | async;

    @if (memo) {
      <textarea
        [disabled]="submitInProgress"
        autocomplete="off"
        class="semeris-thin-scroll"
        rows="12"
        [formControl]="formControl"></textarea>

      <div class="actions">
        <span>
          @if (memo?.updatedAt) {
            Updated at: {{ memo?.updatedAt | userDateTimeFormat }}
          }
        </span>
        <button
          *permissions="[Permissions.WRITE_MEMO]"
          semerisButton
          variant="raised"
          color="accent"
          [disabled]="!formControl.dirty || submitInProgress"
          (click)="onSave()">
          @if (submitInProgress) {
            <semeris-loader [loading]="true" [inline]="true"></semeris-loader>
          } @else {
            Save
          }
        </button>
      </div>
    } @else {
      <semeris-loader class="manager-approval-overlay-loader" [loading]="true" [inline]="true"></semeris-loader>
    }
  </ng-template>
</semeris-hint-overlay>
